/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2021 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import LoginForm from './login-form/LoginForm.js';
import {AppMsg} from './utils';
import {
  fetchTriAppConfig
} from "@tririga/tririga-react-components";

async function initAndRenderApp() {

  // get application information
  await fetchTriAppConfig();

  // initialize static messages
  await AppMsg.initMessages();

  // render the application
  renderApp();
}

async function renderApp() {
  ReactDOM.render(
    <React.StrictMode>
      <LoginForm />
    </React.StrictMode>,
    document.getElementById('root')
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
}

initAndRenderApp();